import styled from 'styled-components'

const EmployeeItem = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin: 0px 10px;
    & img {
        object-fit: cover;
        max-width: 100%;
        width: 250px;
    }
    & > div {
        min-width: 300px;
        margin-left: 20px;
    }
`

export {
    EmployeeItem
}


